import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';

addLocaleData([...en]);

export default {
    /** General Messages Start */
    name: 'Manuscript administration system',

    // Alerts:
    'alert.error': 'Something went wrong, please try again later!',
    'alert.forbidden': 'You are not allowed to view this content!',
    'alert.orcid_denied':
        'Unfortunately, we cannot access your ORCID profile. Please make sure you have granted access to Manuscript application. If it does not help, try to log in using your email address.',
    'alert.users.roles.delete': 'Are you sure you want to delete this role?',
    'alert.submission.phase.change': 'Are you sure you want to change phase of this submission to {phase}?',

    // Page titles
    'title.dashboard': 'Dashboard',
    'title.list': 'List of entities',
    'title.login': 'Login',
    'title.recover': 'Recover',
    'title.reset': 'Reset',
    'title.registration': 'Sign up',
    'title.profile': 'My Profile',
    'title.users': 'Users',
    'title.warning': 'Warning',
    'title.users.general': 'General information',
    'title.users.roles': 'User roles',
    'title.users.roles.add': 'Add new role',
    'title.users.submissions': 'User submissions',
    'title.users.edit': 'Edit User',
    'title.users.create': 'Create User',
    'title.not_found': 'It seems that you are not allowed to use this link anymore. Please contact administrator for details.',
    'title.internal_error': 'Something went wrong',
    'title.journals': 'Journals',
    'title.submissions': 'Submissions',
    'title.submission_create': 'Submit Manuscript',
    'title.forbidden': 'It seems that you don\'t have a permission to view this page. Please contact administrator for details.',
    'title.journal.edit': 'Edit Journal',
    'title.journal.create': 'Create Journal',
    'title.submission.create': 'New Submission',
    'title.submission.edit': 'View Submission',
    'title.send_email': 'New Email',
    'title.emails': 'Emails',
    'title.settings': 'Settings',
    'title.settings.mails': 'Mail Templates',
    'title.settings.mails.edit': 'Edit Mail Template',
    'title.settings.invitations': 'Invitations',
    'title.interests': 'Areas of Interest',
    'title.interest.create': 'Create Area of Interest',
    'title.interest.edit': 'Edit Area of Interest',
    'title.invitations' : 'Invitations',
    'title.invitations.create' : 'Send invitation',
    'title.verify': 'Email verification',
    'title.notifications': 'Notifications',
    'title.notification.edit': 'Edit Notification',
    'title.settings_signatures': 'General',
    'title.author.reminder_after_upload.title': 'Status Change',
    'title.author.reminder_after_upload.text': '',

    'title.settings_general': 'General Settings',

    // Roles
    'role.admin': 'Administrator',
    'role.chief': 'Chief managing editor',
    'role.editorial': 'Managing editor',
    'role.board_member': 'Editorial board member',
    'role.author': 'Author',
    'role.reviewer': 'Reviewer',
    'role.editor': 'Editor',
    'role.accountant': 'Publisher\'s Office',

    // Buttons
    'button.continue': 'Continue',
    'button.register': 'Register',
    'button.login': 'Log in',
    'button.logout': 'Logout',
    'button.close': 'Close',
    'button.cancel': 'Cancel',
    'button.no': 'No',
    'button.more': 'Add more',
    'button.back': 'Back',
    'button.next': 'Next',
    'button.send': 'Send',
    'button.save': 'Save',
    'button.submit': 'Submit',
    'button.yes': 'Yes',
    'button.ok': 'Ok',
    'button.search': 'Search',
    'button.reset': 'Reset',
    'button.password.reset': 'Forgot Password',
    'button.registration': 'Register',
    'button.profile.update': 'Update profile',
    'button.user.create.link': 'Create new user',
    'button.user.role.create': 'Add role',
    'button.submission.create': 'Submit',
    'button.submission.add_coauthor': '+ Add co-author',
    'button.submission.remove_coauthor': '- Remove co-author',
    'button.submission.download_cover_letter': 'Please download and fill the',
    'button.submission.download_cover_letter_link': 'cover letter',
    'button.submission.download_report': 'Please download and fill the',
    'button.submission.download_report_link': 'referee report',
    'button.submission.attach_permission': 'Please attach permission',
    'button.submission.attach_manuscript_blind': 'Please attach manuscript for review',
    'button.submission.download_sample': 'Sample',
    'button.journal.update': 'Update journal',
    'button.journal.create': 'Create journal',
    'button.journal.create.link': 'Create new journal',
    'button.submissions.set_default': 'Set to default',
    'button.submissions.overdue': 'Overdue',
    'button.submissions.new': 'New',
    'button.submissions.filters': 'Filter',
    'button.submissions.my_journals': 'My journal(s)',
    'button.submissions.all_journals': 'All journals',
    'button.submissions.send_email': 'New email',
    'button.submissions.submit_send_email': 'Send email',
    'button.submissions.reply_email': 'Reply',
    'button.lightbox.submit': 'Submit',
    'button.lightbox.cancel': 'Cancel',
    'button.lightbox.skip': 'Skip',
    'button.lightbox.status_change': 'Change Status',
    'button.to.users': 'Back to Users',
    'button.to.login': 'Back to Login',
    'button.to.submissions': 'Back to Submissions',
    'button.to.journals': 'Back to Journals',
    'button.to.emails': 'Back to emails list',
    'button.to.settings.mails' : 'Back to Mail Templates',
    'button.to.interests': 'Back to Areas of Interest',
    'button.to.notifications': 'Back to Notifications',
    'button.to.settings_general': 'Back to General Settings',
    'button.interest.create.link': 'Add area of interest',
    'button.interest.create': 'Add area of interest',
    'button.interest.update': 'Update',
    'button.notification.update': 'Update notification',
    'button.settings_general.update': 'Update Setting',
    'button.comment.send' : 'Add comment',
    'button.comment.show_all' : 'See all comments',
    'button.comment.hide_all' : 'See recent comments',
    'button.file.select' : 'Select file',
    'button.file.upload' : 'Upload new file',
    'button.submission.reject': 'Reject',
    'button.submission.to_revision': 'Author revision',
    'button.submission.to_progress': 'Submit',
    'button.submission.invitations.external': 'Invite External Reviewers',
    'button.invitations.send': 'Invite',
    'button.invitations.new': 'Send invitation',
    'button.reviewers.assign' : 'Invite Reviewers',
    'button.decision.agree': 'Start Publishing Process',
    'button.decision.decline': 'Decline',
    'button.submission.new_round': 'New Round',
    'button.review_disabled.title': 'You need to upload the blind version of manuscript for review',

    // Menu
    'menu.dashboard': 'Dashboard',
    'menu.users': 'Users',
    'menu.login': 'Login',
    'menu.profile': 'My Profile',
    'menu.registration': 'Sign up',
    'menu.journals': 'Journals',
    'menu.submissions': 'Submissions',
    'menu.settings': 'Settings',
    'menu.submission_create': 'Submit Manuscript',
    'menu.privacy_policy': 'Privacy Policy',
    'menu.contacts': 'Contacts',
    'menu.about_the_system': 'About the System',
    'menu.faq': 'FAQ',
    'menu.invitations': 'Invitations',

    // Fields labels and placeholders
    'field.email.label': 'Email',
    'field.confirm_password.label': 'Confirmation password',
    'field.password.label': 'Password',
    'field.password.placeholder': 'Password',
    'field.confirm_password.placeholder': 'Confirm password',
    'field.email.placeholder': 'Email',
    'field.first_name.placeholder': 'First name',
    'field.first_name.label': 'First name',
    'field.last_name.placeholder': 'Last name',
    'field.last_name.label': 'Last name',
    'field.age.placeholder': 'Enter age',
    'field.age.label': 'Age',
    'field.gender.label': 'Gender',
    'field.founder.label': 'Founder',
    'field.founder.placeholder': 'Founder',
    'field.issn_print.label': 'ISSN (print)',
    'field.issn_print.placeholder': 'ISSN (print)',
    'field.issn_online.label': 'ISSN (online)',
    'field.issn_online.placeholder': 'ISSN (online)',
    'field.issued_since_month.label': 'Issued Since (Month)',
    'field.issued_since_month.placeholder': 'Issued Since (Month)',
    'field.issued_since_year.label': 'Issued Since (Year)',
    'field.issued_since_year.placeholder': 'Issued Since (Year)',
    'field.title.label': 'Title',
    'field.title.placeholder': 'Title',
    'field.publisher.label': 'Publisher',
    'field.publisher.placeholder': 'Publisher',
    'field.is_active.label': 'Status',
    'field.is_active.placeholder': 'Status',
    'field.journal_id.placeholder': 'Select journal',
    'field.journal_id.label': 'Select journal',
    'field.journal_id_readonly.label': 'Journal',
    'field.manuscript_author_decision_readonly.label': 'Author\'s Decision',
    'field.title.manuscript_placeholder': 'Enter manuscript title',
    'field.title.manuscript_label': 'Enter manuscript title',
    'field.degree.placeholder': 'Degree and Position',
    'field.degree.label': 'Degree and Position',
    'field.faculty.placeholder': 'Faculty',
    'field.faculty.label': 'Faculty',
    'field.department.placeholder': 'Department',
    'field.department.label': 'Department',
    'field.interests.placeholder': 'Areas of interest',
    'field.interests.label': 'Areas of interest',
    'field.university.placeholder': 'University',
    'field.university.label': 'University',
    'field.university_city.placeholder': 'City',
    'field.university_city.label': 'City',
    'field.university_country.placeholder': 'Country',
    'field.university_country.label': 'Country',
    'field.university_link.placeholder':
        'Your personal webpage at the University (if not applicable please provide LinkedIN, Research Gate, Google Scholar )',
    'field.university_link.label': 'Your personal webpage at the University',
    'field.university_email.placeholder': 'Email',
    'field.university_email.label': 'Email',
    'field.orcid_id.placeholder': 'ORCID',
    'field.orcid_id.label': 'ORCID',
    'field.orcid_link.label': 'Please register your ORCID via this {link}',
    'field.researcher_id.placeholder': 'Researcher ID (if any)',
    'field.researcher_id.label': 'Researcher ID (if any)',
    'field.extract.placeholder': 'Manuscript Abstract',
    'field.extract.label': 'Manuscript Abstract',
    'field.comment.placeholder': 'Add new comment...',
    'field.comment.label': 'Comments',
    'field.key_words.placeholder': 'Keywords',
    'field.key_words.label': 'Keywords',
    'field.manuscript.placeholder': 'Attach manuscript',
    'field.cover_letter.placeholder': 'Attach cover letter',
    'field.review.placeholder': 'Attach review',
    'field.phone.placeholder': 'Mobile Number',
    'field.phone.label': 'Mobile Number',
    'field.country.placeholder': 'Country',
    'field.country.label': 'Country',
    'field.city.placeholder': 'City',
    'field.city.label': 'City',
    'field.zip_code.placeholder': 'Zip Code',
    'field.zip_code.label': 'Zip Code',
    'field.address.placeholder': 'Address',
    'field.address.label': 'Address',
    'field.virtual_id.label': 'ID',
    'field.submissions_active.label': 'Active',
    'field.submissions_archive.label': 'Archive',
    'field.manuscript_title.label': 'Manuscript title',
    'field.manuscript_title.placeholder': 'Manuscript title',
    'field.manuscript_title_readonly.label': 'Title',
    'field.manuscript_authors_readonly.label': 'Author and co-authors',
    'field.abstract_readonly.label': 'Abstract',
    'field.manuscript.label': 'Attach manuscript',
    'field.cover_letter.label': 'Attach cover letter',
    'field.permission.label': 'Attach permission',
    'field.review.label': 'Attach report',
    'field.permission.placeholder': 'Attach permission',
    'field.journal-id.label': 'Journal ID',
    'field.blind.label': 'Blind Version',
    'field.blind.placeholder': 'Blind Version',
    'field.cover_letter_download.label': 'Please download and fill the cover letter',
    'field.email_template.placeholder': 'Email body',
    'field.email_template_additional.placeholder': 'Or enter comma separated emails of unregistered users',
    'field.email_template_additional_recipients.placeholder': 'Enter comma separated emails of additional recipients',
    'field.email_template_subject.placeholder': 'Subject',
    'field.subject.label': 'Subject',
    'field.subject.placeholder': 'Subject',
    'field.body.label': 'Body',
    'field.body.placeholder': 'Body',
    'field.attach.manuscript.label': 'Manuscript',
    'field.attach.manuscript_blind.label': 'Manuscript for Review',
    'field.attach.cover_letter.label': 'Cover Letter',
    'field.attach.permission.label': 'Permission',
    'field.attach.review.label': 'Referee Report',
    'field.user_active.label': 'Activation status',
    'field.manuscript_comments.label': 'Comments',
    'field.assign_type_all.label': 'Assign to review',
    'field.assign_type_board.label': 'Choose Editorial Board member to handle review',
    'field.email_recipients.placeholder': 'Choose email recipients',
    'field.has_full_pool.label': 'Access to full reviewers pool',
    'field.has_full_pool.placeholder': 'Access to full reviewers pool',
    'field.previous_review_rounds.label': 'Previous rounds of peer review',
    'field.current_review_round.label': 'Current round of peer review',
    'field.alias.label': 'Alias',
    'field.period.label': 'Number of days before remind',
    'field.period.placeholder': 'Number of days',
    'field.is_repeat.label': 'Repeat reminder sending',
    'field.is_repeat.placeholder': 'Repeat reminder sending',
    'field.is_business_days.label': 'Business days only',
    'field.is_business_days.placeholder': 'Business days only',
    'field.notification.is_active.label': 'Is active',
    'field.notification.is_active.placeholder': 'Is active',
    'field.value.label': 'Value',
    'field.value.placeholder': 'Value',
    'field.email_signature.label': 'Email signature',
    'field.email_signature.placeholder': 'Email signature',
    'field.email_system_signature.label': 'Email system signature',
    'field.email_system_signature.placeholder': 'Email system signature',
    'field.manuscript_blind.placeholder': 'Manuscript for Review',
    'field.created_at.placeholder': 'Created',

    //Form groups
    'form_groups.journal_selection': 'Journal Selection',
    'form_groups.author_info': 'Author-Correspondent Personal Information',
    'form_groups.contact_info': 'Contact information',
    'form_groups.orcid_register': 'If you have ORCID, you can',
    'form_groups.corporate_info': 'Corporate Address',
    'form_groups.password': 'Password',
    'form_groups.consents': 'Consents',
    'form_groups.address_info': 'Address Details',
    'form_groups.professional_info': 'Professional Occupation',
    'form_groups.university_info': 'Business Address',
    'form_groups.ids_info': 'ID’s',
    'form_groups.manuscript_info': 'Manuscript Details',
    'form_groups.coauthors': 'Co-authors',
    'form_groups.coauthor_info': 'Contact Information',
    'form_groups.coauthor_professional': 'Professional Occupation',
    'form_groups.status': 'Status',
    'form_groups.general': 'General',
    'form_groups.version_history': 'Files',
    'form_groups.external_overview': 'External Reviewers Overview',
    'form_groups.assign_reviewers': 'Assign Reviewers to Submission',
    'form_groups.active_roles': 'Active roles',
    'form_groups.roles_history': 'Roles history',
    'form_groups.created': 'Created',

    // Validation errors
    'validation.error.required': 'Value required',
    'validation.error.invalid_email': 'Invalid email',
    'validation.error.invalid_emails': 'One of emails is invalid',
    'validation.error.gt': 'Value should be greater than {value}',
    'validation.error.gte': 'Value should be greater than or equal {value}',
    'validation.error.lt': 'Value should be less than {value}',
    'validation.error.lte': 'Value should be less than or equal {value}',
    'validation.error.equal_to': 'Value of this field should be identical to {value}',
    'validation.error.min': 'Too short. Min length {min} characters',
    'validation.error.max': 'Too long. Max length {max} characters',
    'validation.error.words.max': 'Too long. Max {max} words',
    'validation.error.date.min': 'Date should be greater than {min}',
    'validation.error.date.max': 'Date should be less than {max}',
    'validation.error.password_strong':
        'Password must contain a special character and uppercase letter',
    'validation.error.orcid': 'ORCID should be in (xxxx-xxxx-xxxx-xxxx) format',
    'validation.error.not_a_number': 'Value should be in number format',
    'validation.error.confirmation_password': 'Passwords don\'t match',
    'validation.error.file_required': 'File required',
    'validation.error.file_type': 'Illegal file type',
    'validation.error.not_a_year': 'Value should be a valid year',
    'validation.error.invalid_link': 'Invalid link',
    'validation.error.max_size': 'File is too large. Max {max} MB',

    // Select types
    'types.gender.man': 'Man',
    'types.gender.woman': 'Woman',
    'types.status.inactive': 'Inactive',
    'types.status.active': 'Active',
    'types.status.rejected': 'Rejected',
    'types.status.published': 'Publication Process',
    'types.status.author_revision': 'Author’s revision',
    'types.status.in_progress': 'In progress',
    'types.status.invited': 'Invited',
    'types.status.declined': 'Disagreed',
    'types.status.accepted': 'Agreed',
    'types.attachment.manuscript': 'Manuscript',
    'types.attachment.manuscript_blind': 'Manuscript for Review',
    'types.attachment.cover_letter': 'Cover Letter',
    'types.attachment.review': 'Review',
    'types.attachment.blind': 'Blind Version',
    'types.attachment.permission': 'Permission',
    'types.month.1': 'January',
    'types.month.2': 'February',
    'types.month.3': 'March',
    'types.month.4': 'April',
    'types.month.5': 'May',
    'types.month.6': 'June',
    'types.month.7': 'July',
    'types.month.8': 'August',
    'types.month.9': 'September',
    'types.month.10': 'October',
    'types.month.11': 'November',
    'types.month.12': 'December',
    'types.submissions.overdue': 'Overdue',
    'types.submissions.new': 'New',
    'types.activity.comment': 'Comment added',
    'types.activity.email': 'Email sent',
    'types.activity.phase': 'Phase changed',
    'types.activity.status': 'Status changed',
    'types.activity.decision': 'Author\'s decision',
    'types.activity.download': 'File downloaded',
    'types.activity.overdue': 'Overdue',
    'types.activity.review_completed': 'Review completed',

    /** General Messages End */

    // Error page
    'error_page.header.not_found': 'Error. Page not found!',
    'error_page.header.internal_error': 'Something went wrong',
    'error_page.message.internal_error': 'Please try again later or contact with us',
    'error_page.link_back': 'Go Back',
    'error_page.link_home': 'Go Home',
    'error_page.header.forbidden': 'Error. You are not allowed to execute action!',

    // Login
    'login.header': 'Sign in',
    'login.success': 'You have been successfully logged in',
    'login.error': 'Invalid password or email has not been verified',

    // Registration
    'registration.header': 'Sign up',
    'registration.consents.gdpr':
        'We pay a significant attention to the personal data security.  With GDPR in force we’d like to ask you to get acquainted with our {link} document and to allow us processing and storing your personal data left during registration and manuscript submissions.',
    'registration.consents.gdpr_subtitle': 'I agree that my personal data from registration form and my profile will be used by {link} with the following purposes:',
    'registration.consents.notifications': 'To send notifications and emails on manuscript review procedures and status',
    'registration.consents.send_manuscript': 'To send your manuscript to the editorial board members and external reviewers according to the review process',
    'registration.consents.become_reviewer': 'To review the manuscripts',
    'registration.consents.register': 'To use my personal data to register my account',
    'registration.consents.orcid': 'To use my personal data to login via ORCID',
    'registration.consents.notifications_auth': 'To send me email notifications related to authorization and account changes',

    // User
    'user.tab.general': 'General',
    'user.tab.roles': 'Roles',
    'user.tab.submissions': 'User Submissions',
    'profile.tab.general': 'General',
    'profile.tab.reviews': 'Finished Reviews',

    // Submission
    'submission.tab.general': 'General',
    'submission.tab.emails': 'Emails {newEmailsCount}',
    'submission.tab.files': 'Files',
    'submission.tab.activities': 'Activity log',
    'submission.decision.agreed': 'Agreed to start publishing process',
    'submission.decision.declined': 'Declined',
    'submission.decision.wait': 'Waiting for decision',
    'submission.phase.new': 'New Submission',
    'submission.comments.empty': 'No comments yet',

    // Settings
    'settings.tab.mails': 'Mail templates',
    'settings.tab.interests': 'Areas of interest',
    'settings.tab.notifications': 'Notifications',
    'settings.tab.general': 'General',

    // Settings|Invitations
    'invitations.title.step.reviewers': 'Choose reviewers',
    'invitations.title.step.mail': 'Edit email',
    'invitations.title.step.confirmation': 'Final',
    'invitations.summary': 'Invitation(s) to {journal} Journal will be sent to the following people:',
    'invitations.confirm': 'Please confirm by pressing the "Invite" button.',

    // Profile
    'profile.header': 'My Profile',
    'authors.info': 'Contact information',
    'authors.full_name': 'Full name',
    'authors.email': 'Email',
    'authors.degree': 'Degree and position',
    'authors.faculty': 'Faculty',
    'authors.department': 'Department',
    'authors.university': 'University',
    'authors.orcid': 'ORCID',
    'authors.researcher_id': 'Researcher ID',

    //Data table
    'data_table.id': 'ID',
    'data_table.email': 'E-mail',
    'data_table.created_at': 'Created',
    'data_table.from': 'From',
    'data_table.to': 'To',
    'data_table.name': 'Name',
    'data_table.role.name': 'Role',
    'data_table.none': 'Select all',
    'data_table.no_results_found': 'No results found',
    'data_table.title': 'Title',
    'data_table.issn_print': 'ISSN (print)',
    'data_table.issn_online': 'ISSN (online)',
    'data_table.is_active': 'Status',
    'data_table.journal_id': 'Journal',
    'data_table.status_id': 'Phase',
    'data_table.virtual_status': 'Status',
    'data_table.submission_created_at': 'Submission Date',
    'data_table.submission_updated_at': 'Last action',
    'data_table.authors': 'Author',
    'data_table.empty': ' ',
    'data_table.alias': 'Alias',
    'data_table.invitation.status' : 'Status',
    'data_table.submissions.empty': 'You have no submissions.',
    'data_table.users_count': 'Count of users with this interest',
    'data_table.interests': 'Area of interest',
    'data_table.assign': 'Last assignment',
    'data_table.assign_action': 'Assign',
    'data_table.invitations': 'Invitations',
    'data_table.reviewer': 'Reviewer name',
    'data_table.reviewer_email': 'Reviewer email',
    'data_table.invitation_date': 'Invitation Date',
    'data_table.invitation_status': 'Invitation result',
    'data_table.report': 'Referee report',
    'data_table.report_date': 'Referee report date',
    'data_table.response_date': 'Response Date',
    'data_table.founder': 'Founder',

    'data_table.filter.id': 'Select ID',
    'data_table.filter.email': 'Enter e-mail',
    'data_table.filter.date': 'Enter date',
    'data_table.filter.title': 'Title',
    'data_table.filter.journal_title': 'Select journal',
    'data_table.filter.submission_id': 'ID',
    'data_table.filter.journal.title': 'Journal',
    'data_table.filter.name': 'Select User',
    'data_table.filter.role_id': 'Select User Role',
    'data_table.filter.journal_id': 'Select Journal',
    'data_table.filter.author.title': 'Author or co-author',
    'data_table.filter.date.from': 'From ',
    'data_table.filter.date.to': 'To',
    'data_table.filter.process_status': 'Status',
    'data_table.filter.status_id': 'Phase',
    'data_table.filter.interest_title': 'Select interests',
    'data_table.filter.interests': 'Select interests',

    // Reset password
    'recover.title': 'Recover password',
    'recover.subtitle':
        'Please enter your email registered in the system. You will receive a link to reset your password to this email.',

    'reset.title': 'Reset password',
    'reset.subtitle':
        'Please enter and confirm your new password here. Please note, that the password should contain min 6 characters, 1 special character, 1 Uppercase character.',

    'files.cover_letter_title': 'COVER_LETTER_FORM.docx',
    'files.report_title': 'REFEREE_REPORT_FORM.docx',
    'files.max_size': 'Max size is {max} MB',

    // Emails
    'email.text.send': 'Please choose recipients, edit the letter and click the "Send Email" button.',
    'email.text.send_recipients': 'Please edit the letter and click the "Send Email" button.',
    'email.text.assign': 'Please edit the letter and click the send button.',

    // Confirmations
    'confirm.delete': 'Are you sure you want to delete this record?',
    'confirm.skip.reviewers': 'Are you sure you want to change submission phase without reviewers assignation?',

    // Icons
    'icon.title.overdue': 'Overdue Submission',
    'icon.title.new': 'New Submission',
    'icon.title.has_notification': 'Has new event',

    // Login
    'login.tab.login': 'Log in',
    'login.tab.register': 'Register',
};



// WEBPACK FOOTER //
// ./src/locales/en.js